import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SimpleEntityDataService } from '../../services/searchable-entity/simple-entity/simple-entity-data.service';
import { SharedServiceRegistry } from '../../shared-service-registry';


@Injectable()
export class ExcludeFromZonePopupDataService extends SimpleEntityDataService {

    public mandatoryProperties: any;
    
    constructor(protected coreServiceRegistry: CoreServiceRegistry,
        protected sharedServiceRegistry: SharedServiceRegistry) {
        super(coreServiceRegistry, sharedServiceRegistry);
    }

    public handleAddNewRow(newRow: any) {
        if (this.mandatoryProperties && this.mandatoryProperties.length > 0) {
            this.mandatoryProperties.forEach(property => {
                newRow.cells[property.cName].cVal = property.cVal;
            });
        }
    }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/exclude-from-zone-popup/exclude-from-zone-popup-data.service.ts